<!--合作模式 2020-03-18 Sag-->
<template>
  <div class="its-cooperate">
    <p class="its-cooperate-title">合作方式</p>
    <ts-page-layout center>
      <div class="its-cooperate-container its-left" @click="toPage('school', '2-1')">
        <div class="its-cooperate-container-title">
          <p>学校智慧教学解决方案</p>
        </div>
        <p class="its-cooperate-desc">打造“教、学、管、评、测、研”智慧教学闭环，为教师增效，为学生减负，帮助学校科学管理，让教与学更高效</p>
        <p class="its-cooperate-desc its-cooperate-desc-2">适合学校、代理商、集成商采购，支持纯软件合作、软硬件一条龙合作。</p>
      </div>
      <div class="its-cooperate-container its-right" @click="toPage('area', '2-2')">
        <div class="its-cooperate-container-title">
          <p>区域智慧教育解决方案</p>
        </div>
        <p class="its-cooperate-desc">专为区校打造，助力学校智慧教学，辅助区域统筹管理，实现区校一体化建设，缩小区域、城乡、校际差距，促进区域教育资源均衡配置。</p>
        <p class="its-cooperate-desc its-cooperate-desc-2">适合教育局、电教馆等教育主管单位采购，支持纯软件、软硬件一条龙合作，也支持定制化服务。</p>
      </div>
    </ts-page-layout>
  </div>
</template>
<script>
export default {
  name:'Cooperate',
  methods: {
    toPage: function (page, navId) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$root.activeNavigation(navId)
      this.$router.push('/eclass/' + page)
    }
  }
}
</script>
<style scoped>
.its-cooperate{
  background-color: white;
  padding-top: 100px;
  padding-bottom: 50px;
}

.its-cooperate-title {
  font-size: 36px;
  color: #333333;
  text-align: center;
  margin-bottom: 39px;
}

.its-cooperate-container {
  width: 502px;
  height: 278px;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
}

.its-left {
  float: left;
  background-image: url(../../../../assets/images/home/cooperate_1.png);
  background-size: 100%;
}

.its-right {
  float: right;
  background-image: url(../../../../assets/images/home/cooperate_2.png);
  background-size: 100%;
}

.its-cooperate-container-title {
  text-align: center;
  height: 103px;
  font-size: 30px;
  color: white;
  background-color: #6088E9;
  padding-top: 13px;
  line-height: 73px;
}

.its-cooperate-container-title p:hover {
   opacity: 0.9;
}

.its-cooperate-container-title span{
  font-size: 18px;
  color: #6088E9;
  display: inline-block;
  padding: 2px 15px;
  background-color: white;
  border-radius: 15px;
}

.its-cooperate-desc {
  color: black;
  font-size: 16px;
  text-align: left;
  padding: 20px 27px 0 42px;
}

.its-cooperate-desc-2 {
  padding-top: 24px;
  font-weight: 500;
}


.its-btn-details {
  width: 112px;
  height: 30px;
  line-height: 30px;
  background-color: #6087E9;
  cursor: pointer;
  text-align: center;
  color: white;
  font-size: 18px;
  border-radius: 15px;
  border: none;
}

.its-btn-details:hover {
  opacity: 0.8;
}


</style>